export interface Bank {
  id: number;
  bik: string;
  name: string;
}

export const BANKS: Bank[] = [
  { id: 1, bik: "CASPKZKA", name: 'АО "Kaspi Bank"' },
  { id: 2, bik: "HSBKKZKX", name: 'АО "Народный Банк Казахстана"' },
  { id: 3, bik: "KCJBKZKX", name: 'АО "Банк ЦентрКредит"' },
  { id: 4, bik: "IRTYKZKA", name: 'АО "ForteBank"' },
  { id: 5, bik: "EABRKZKA", name: "Евразийский Банк Развития" },
  { id: 6, bik: "INLMKZKA", name: 'АО "Home Credit Bank"' },
  { id: 7, bik: "BKCHKZKA", name: 'АО ДБ "Банк Китая в Казахстане"' },
  { id: 8, bik: "KSNVKZKA", name: 'АО "Фридом Банк Казахстан"' },
  { id: 9, bik: "ATYNKZKA", name: 'АО "Altyn Bank"' },
  { id: 10, bik: "TSESKZKA", name: 'AO "Alatau City Bank"' },
  { id: 11, bik: "SHBKKZKA", name: 'АО "Шинхан Банк Казахстан"' },
  { id: 12, bik: "NURSKZKX", name: 'АО "Нурбанк"' },
  { id: 13, bik: "ZAJSKZ22", name: 'АО "Исламский банк "Заман-Банк"' },
  { id: 14, bik: "ICBKKZKX", name: 'АО "Торгово-промышленный Банк Китая в г. Алматы"' },
  { id: 15, bik: "HLALKZKZ", name: "АО «Исламский Банк «ADCB»" },
  { id: 16, bik: "KZIBKZKA", name: 'АО "ДБ "Казахстан-Зираат Интернешнл Банк"' },
  { id: 17, bik: "MOKFKZKA", name: "Акционерное общество «Коммерческий Банк БиЭнКей»" },
  { id: 18, bik: "VTBAKZKZ", name: "ДО АО Банк ВТБ (Казахстан)" },
  { id: 19, bik: "KMFBKZKK", name: 'Акционерное общество "КМФ Банк"' },
  { id: 20, bik: "KINCKZKA", name: 'АО "Банк "Bank RBK"' },
  { id: 21, bik: "BRKEKZKA", name: 'АО "Bereke Bank"' },
  { id: 22, bik: "EURIKZKA", name: 'АО "Евразийский Банк"' },
  { id: 23, bik: "CITIKZKA", name: 'АО "Ситибанк Казахстан"' },
];

